/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Payment_Method_Change_Receipt_NoteInputs */

const vi_order_payment_method_change_receipt_note = /** @type {(inputs: Order_Payment_Method_Change_Receipt_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoản này thuộc một phiếu thu của khách: đổi sẽ đổi cả phiếu thu và mọi đơn được trả bằng phiếu đó.`)
};

/**

* @param {Order_Payment_Method_Change_Receipt_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_payment_method_change_receipt_note = /** @type {((inputs?: Order_Payment_Method_Change_Receipt_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Payment_Method_Change_Receipt_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_payment_method_change_receipt_note(inputs)
});